import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {findDOMNode} from 'react-dom';
import _ from 'lodash';

import blueTemplate from '../../../templates/PageLayout/DropDowns/BlueDropDown.rt';
import grayTemplate from '../../../templates/PageLayout/DropDowns/GrayDropDown.rt';
import * as Misc from "../../../misc";

class BlueDropDown extends PureComponent {
  static propTypes = {
    onItemClick: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    selectedItem: PropTypes.any,
    large: PropTypes.bool,
    itemKey: PropTypes.func,
    itemValue: PropTypes.func,
    dropdownToggleCallBack: PropTypes.func,
    templateType: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpened: this.props.isOpened || false,
      selectedItem: this.props.selectedItem,
      large: this.props.large === undefined ? false : this.props.large,
      selectedItemKey: this.itemKey(this.props.selectedItem),
      dropDownRef: null
    };
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {
    this.setState({
      selectedItem: this.props.selectedItem,
      selectedItemKey: this.itemKey(this.props.selectedItem)});
  }

  itemKey = (item) => {
    if (!item)
      return '';
    return this.props.itemKey ? this.props.itemKey(item) : item;
  };

  itemValue = (item) => {
    if (!item)
      return '';
    return this.props.itemValue ? this.props.itemValue(item) : item;
  };

  handleItemClick = (e, item) => {
    Misc.ignoreDefault(e);
    this.setState({isOpened: false, selectedItem: item, selectedItemKey: this.itemKey(item)});
    this.props.onItemClick(item);
  };

  handleDropdownButton = (e) => {
    Misc.ignoreDefault(e);
    const opening = !this.state.isOpened;
    this.setState({isOpened: opening}, () => {
      if (opening) {
        findDOMNode(this.state.dropDownRef).focus();
      }
    });
    if (this.props.dropdownToggleCallBack) {
      this.props.dropdownToggleCallBack(opening)
    }
  };

  handleOnBlur = () => {
    this.setState({isOpened: false});
    if (this.props.dropdownToggleCallBack) {
      this.props.dropdownToggleCallBack(false)
    }
  };

  render() {
    switch(this.props.templateType) {
      case "gray":
        return grayTemplate.apply(this);
      default:
        return blueTemplate.apply(this);
    }
  }
}

export default BlueDropDown;

